module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('h1', [_vm._v("Run finished")]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('stats-card'), _vm._v(" "), _c('el-card', {
    staticClass: "video",
    attrs: {
      "body-style": {
        height: '100%',
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Done!")])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": "https://www.youtube.com/embed/6ktnrKG8uq4?autoplay=1&cc_load_policy=1",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19bd690a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project-finished.vue
// module id = 708
// module chunks = 1